<script lang="ts">
import {defineComponent} from 'vue';
import {DataInput, TreeUtil} from '@/components/common/tree/TreeUtil';

export default defineComponent({
  name: 'ScTree',
  props: {},
  setup() {
    return {
      tree: new TreeUtil(),
    };
  },
  methods: {
    setData(data: DataInput<any>) {
      this.tree.setData(data);
    },
    getRoot() {
      return this.tree.getRoot();
    },
    setOpenedAll(opened: boolean) {
      this.tree.setOpenedAll(opened);
    },
    openNode(id: string) {
      this.tree.openNode(id);
    },
    getSelectedNode() {
      return this.tree.getSelectedNode();
    },
    checkMove(
      nodeId: string,
      targetNodeId: string,
      pos: 'before' | 'after' | 'inside'
    ) {
      return this.tree.checkMove(nodeId, targetNodeId, pos);
    },
    moveNodeTo(
      nodeId: string,
      targetNodeId: string,
      pos: 'before' | 'after' | 'inside'
    ) {
      return this.tree.moveNodeTo(nodeId, targetNodeId, pos);
    },
  },
  render() {
    return this.tree.render(this.$slots.default);
  },
});
</script>
